import {
  UsersAuthsClient,
  OAuthProvider,
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";
import authConfig from "../config/auth-config";
import { getCurrentOrigin } from "../utils/helpers";

const userAuth = new UsersAuthsClient(apiConfig, undefined, axiosInstance);

const handleVerifyAuth = async (idToken: string, provider: OAuthProvider) => {
  try {
    const { data: userInfo } = await userAuth.verifyOauth({
      idToken,
      provider,
    });
    return userInfo;
  } catch {
    return;
  }
};

const handleInitiateAuth = async (
  provider: OAuthProvider,
  redirectPath?: string,
  fallbackPath?: string
) => {
  const isPreview = process.env.REACT_APP_IS_PREVIEW_ENVIRONMENT === "1";
  const currentOrigin = getCurrentOrigin();

  try {
    const baseUrl = isPreview ? currentOrigin : authConfig.baseUrl;
    const redirectUrl = `${baseUrl}${
      redirectPath || authConfig.onboardingRedirectPath
    }`;
    const { initializationUrl } = (
      await userAuth.initOauth(
        provider === OAuthProvider.GOOGLE
          ? OAuthProvider.GOOGLE
          : OAuthProvider.FACEBOOK,
        {
          redirectUrl,
        }
      )
    ).data;
    if (!initializationUrl) {
      window.location.href = `${baseUrl}${
        fallbackPath || authConfig.fallbackRedirectPath
      }`;
      return;
    }
    window.location.href = initializationUrl;
  } catch {
    return;
  }
};

export { handleVerifyAuth, handleInitiateAuth };
